/**
 * 维修无忧
 */
import { REPAIRRECORD } from '../types';

export default {
    name: `${REPAIRRECORD}`,
    path: '/repairRecord',
    component: () => import(/* webpackChunkName: 'repairRecord' */ '@/views/repairRecord/'),
    redirect: { name: `${REPAIRRECORD}Index` },
    meta: {
        title: '维修无忧',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${REPAIRRECORD}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'repairRecord' */ '@/views/repairRecord/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${REPAIRRECORD}Detail`,
            path: 'detail/:id',
            component: () => import(/* webpackChunkName: 'repairRecord' */ '@/views/repairRecord/detail/Detail.vue'),
        },
    ],
};
